(function($){
	// Object definition
	$.inkiveCommon = true;

	function API(url, method, params, callback, options) {
		method = method || 'GET';
		params = params || null;
		callback = callback || $.noop;

		this.options = $.extend({
			beforeSend : $.noop,
			ms         : 30000
		}, options || {});

		this.url = url;
		this.method = method;
		this.data = params;
		this.type = 'json';
		this.callback = callback;
	}

	API.prototype.request = function() {
		var that = this;

		$.ajax({
			type		: that.method,
			url			: that.url,
			timeout		: that.options.ms,
			data		: that.data,
			beforeSend	: that.options.beforeSend,
			complete	: function(r) {
				if(that.callback.length < 2) {
					try {
						var res = checkResponse(r);
						that.callback(res);
					}
					catch(e) {
						console.log(e);
					}
				}
				else {
					try {
						var res = checkResponse(r);
					}
					catch(e) {
						that.callback(res, false, e.status, e.errorCode, e.userMessage);
						return;
					}
					that.callback(res, true);
				}

			}
		});
	};

	API.prototype.multipartRequest = function() {
		var that = this;

		$.ajax({
			type        : 'POST',
			url         : that.url,
			data        : that.data,
			beforeSend	: that.options.beforeSend,
			async       : false,
			cache       : false,
			contentType : false,
			processData : false,
			complete	: function(r) {
				try {
					var res = checkResponse(r);
					that.callback && that.callback(res);
				}
				catch(e) {
					console.log(e);
				}
			}
		});
	};

	function checkResponse(r) {
		try {
			var res = $.parseJSON(r.responseText);
		}
		catch(e) {
			console.error(r.responseText);
			throw {
				'status': 0,
				'errorCode': 0,
				'userMessage': 'Unable to open the project. Please try again or contact info@desygner.com for support'
			};
		}

		if(r.status !== 200) throw {
			status      : r.status,
			errorCode   : res.errorCode,
			userMessage : res.userMessage
		};

		return res;
	}

	// Bad Browser Checker
	function Browser(bad) {
		this.bad = $.extend({ 'msie': '<= 9' }, bad);
		this.browser = $.browser;
	}

	Browser.prototype.checkVersion = function(nowVersion, logic) {
		var ar_logic = logic.split(' ');
		var expr = ar_logic[0];
		var version = parseFloat(ar_logic[1]);
		nowVersion = parseFloat(nowVersion);

		switch(expr) {
			case '<=': return nowVersion <= version;
			case '<': return nowVersion < version;
			case '>=': return nowVersion >= version;
			case '>': return nowVersion > version;
			case '==': default: return nowVersion == version;
		}
	};

	Browser.prototype.check = function() {
		var boolen = false;

		for(var i in this.bad)
			if(this.browser.hasOwnProperty(i))
				boolen = this.checkVersion(this.browser.version, this.bad[i]);

		return boolen;
	};

	function InkiveAlert(options, el) {
		this.$container = $(el);
		this.$container.hide();

		this.options = $.extend({
			html      : true,
			type      : 'default',
			message   : 'no message',
			alertType : 'default',
			loader    : false,
			button    : [],
			callback  : [],
			skip      : false
		}, options);

		this.type = this.options.type;
		this.message = this.options.message;

		switch(this.type) {
			case 'topbar': this.topbar(); break;
			default: this.windowAlert();
		}
	}
	// Basic functions
	InkiveAlert.prototype.container = function() {
		return this.$container;
	};

	InkiveAlert.prototype.setMessage = function(elem, message) {
		if(this.options.html)	$(elem).find('.ik-alert-content').append(message);
		else					$(elem).find('.ik-alert-content').text(message);
	};

	// Alert type
	InkiveAlert.prototype.topbar = function() {
		function show() {
//			$container.show();
			$container.css('display', 'block');
			$('.navbar-inkive').css('margin-top', $container.height());
			$('body').css('margin-top', $container.height());
		}
		function hide() {
//			$container.hide();
			$container.css('display', 'none');
			$('.navbar-inkive').css('margin-top', 0);
			$('body').css('margin-top', 0);
		}

		var $container = this.$container;
		var html = $.parseHTML('<div class="ik-alert-wrapper"><div class="ik-alert-content"></div><a><span class="ik-alert-close"><i class="fa fa-times fa-2x"></i></span></a></div>');
		$(html).addClass('ik-'+this.options.alertType);
		this.setMessage(html, this.message);
		$(html).find('.ik-alert-close').on('click', function(e) {
			hide();
		});
		if(!this.$container.hasClass('ik-alert-topbar')) this.$container.addClass('ik-alert-topbar');

		this.$container.append(html);
		this.$container.hide = hide;
		this.$container.show = show;
		show();
	};

	InkiveAlert.prototype.windowAlert = function() {
		window.alert(this.message);
	};

	// jquery global function call
	$.extend({
		api: function(url, method, params, callback, options) {
			var ajax = new API(url, method, params, callback, options);
			ajax.request();
		},
		apiMultipart: function(url, params, callback, options) {
			var ajax = new API(url, 'POST', params, callback, options);
			ajax.multipartRequest();
		},
		badBrowser: function(bad) {
			var browser = new Browser(bad);
			return browser.check();
		},
		logoLoader: function(boolen) {
			if(boolen) {
				$('.logo-inkive img').fadeOut('slow', function(e) {
					$('.logo-inkive').append('<div class="pace pace-active"><div class="pace-activity"></div></div>');
					$('.logo-inkive').trigger('ik.loading.start');
				});
			} else {
				$('.logo-inkive').on('ik.loading.start', function(e) {
					$('.logo-inkive .pace').remove();
					$('.logo-inkive img').fadeIn('slow');
				});
				$('.logo-inkive').trigger('ik.loading.start');
				$('.logo-inkive').trigger('ik.loading.end');
			}
		}
	});

	// jquery local function call
	$.fn.extend({
		ikAlert: function(type, message, o) {
			return this.each(function(e) {
				var options = o || {};

				options['type'] = type;
				options['message'] = message;

				var inkiveAlert = new InkiveAlert(options, this);
				$.data(this, "ik-alert", inkiveAlert);
			});
		}
	});
})(jQuery);
